import * as types from '../../mutation-types'

const state = {
  loadingStatus: false
}
// getters
const getters = {
  loadingStatus: (state) => state.loadingStatus
}

const actions = {
  changeLoadingStatus ({commit}, status) {
    commit(status ? types.LOADING_START : types.LOADING_END)
  }
}

const mutations = {
  [types.LOADING_START] (state) {
    state.loadingStatus = true
  },
  [types.LOADING_END] (state) {
    state.loadingStatus = false
  },
  SOCKET_RECONNECT (state) {
    state.loadingStatus = false
  },
  SOCKET_RECONNECT_ERROR (state) {
    state.loadingStatus = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loader/index.js